import { IBaseIconProps } from "./IBaseIconProps";

// Line art drawn as filled shapes (PrimeIcons "megaphone", MIT), like GiftIcon: the sidebar
// forces `fill` on every icon shape, so a stroked outline would turn into a blob.
export const MegaphoneIcon = ({ color = "#ffffff" }: IBaseIconProps) => {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M18.17,4.44h-1.34c-1.01,0-1.83,.82-1.83,1.83v.45l-9.5,2.04v-.51c0-.41-.34-.75-.75-.75s-.75,.34-.75,.75v7c0,.41,.34,.75,.75,.75s.75-.34,.75-.75v-.63l9.5,2.04v.45c0,1.01,.82,1.83,1.83,1.83h1.34c1.01,0,1.83-.82,1.83-1.83V6.27c0-1.01-.82-1.83-1.83-1.83ZM5.5,13.08v-2.79l9.5-2.04v6.87l-9.5-2.04Zm13,4.03c0,.18-.15,.33-.33,.33h-1.34c-.18,0-.33-.15-.33-.33V6.27c0-.18,.15-.33,.33-.33h1.34c.18,0,.33,.15,.33,.33v10.84Zm-5.53,.52c-.37,1.16-1.44,1.94-2.67,1.94-1.54,0-2.8-1.24-2.8-2.75,0-.11,0-.23,.02-.34,.05-.41,.43-.7,.84-.65,.41,.05,.7,.42,.65,.83,0,.05,0,.1,0,.15,0,.69,.58,1.25,1.3,1.25,.57,0,1.07-.36,1.24-.89,.12-.4,.55-.62,.94-.49,.4,.12,.61,.55,.49,.94Z" />
    </svg>
  );
};
